class D6Configurator {
  constructor(root) {
    this.root = root;
    try {
      this.productConfig = JSON.parse(root.querySelector('[data-d6-product-config]')?.textContent || '{}');
    } catch (error) {
      this.productConfig = {};
    }
    if (this.productConfig.enabled === false) {
      if (!this.productConfig.designMode) {
        root.hidden = true;
        return;
      }
      const warning = document.createElement('p');
      warning.className = 'd6-configurator__disabled-warning page-width';
      warning.textContent = 'El configurador D6 está desactivado en este producto. Activa “D6 · Activar configurador” en la ficha del producto para mostrarlo a los clientes.';
      root.prepend(warning);
    }
    const configuredFaces = Array.isArray(this.productConfig.editableFaces) ? this.productConfig.editableFaces.map(Number).filter((face) => face >= 1 && face <= 6) : [];
    this.editableFaces = new Set(configuredFaces.length ? configuredFaces : [1, 2, 3, 4, 5, 6]);
    this.svgNamespace = 'http://www.w3.org/2000/svg';
    this.xlinkNamespace = 'http://www.w3.org/1999/xlink';
    this.sectionId = root.dataset.sectionId;
    this.state = Array.from({ length: 6 }, (_, index) => ({
      mode: 'pips', image: null, svgSource: null, vectorRaster: null, vectorKey: null, size: 76, number: index + 1,
    }));
    this.opposites = [5, 4, 3, 2, 1, 0];
    this.selectedFace = null;
    this.renderTimer = 0;
    this.vectorTimer = 0;
    this.preparedSubmit = false;
    this.pips = {
      1: [[200, 200]], 2: [[120, 120], [280, 280]], 3: [[110, 110], [200, 200], [290, 290]],
      4: [[115, 115], [285, 115], [115, 285], [285, 285]],
      5: [[110, 110], [290, 110], [200, 200], [110, 290], [290, 290]],
      6: [[115, 95], [285, 95], [115, 200], [285, 200], [115, 305], [285, 305]],
    };
    this.layouts = [
      { faces: [0, 1, 2], points: { top: [[450, 115], [740, 285], [450, 455], [160, 285]], left: [[160, 285], [450, 455], [450, 745], [160, 575]], right: [[450, 455], [740, 285], [740, 575], [450, 745]] }, transforms: { top: 'matrix(.725,-.425,.725,.425,160,285)', left: 'matrix(.725,.425,0,.725,160,285)', right: 'matrix(.725,-.425,0,.725,450,455)' } },
      { faces: [5, 3, 4], points: { top: [[1150, 115], [1440, 285], [1150, 455], [860, 285]], left: [[860, 285], [1150, 455], [1150, 745], [860, 575]], right: [[1150, 455], [1440, 285], [1440, 575], [1150, 745]] }, transforms: { top: 'matrix(.725,-.425,.725,.425,860,285)', left: 'matrix(.725,.425,0,.725,860,285)', right: 'matrix(.725,-.425,0,.725,1150,455)' } },
    ];
    this.keys = ['top', 'left', 'right'];
    this.material = root.querySelector('[data-d6-material]');
    this.dieColor = root.querySelector('[data-d6-die-color]');
    this.pipColor = root.querySelector('[data-d6-pip-color]');
    this.cornerStyle = root.querySelector('[data-d6-corners]');
    this.recolorSvg = root.querySelector('[data-d6-recolor]');
    this.dieColorCode = root.querySelector('[data-d6-die-color-code]');
    this.dieColorControl = root.querySelector('[data-d6-die-color-control]');
    this.pipColorCode = root.querySelector('[data-d6-pip-color-code]');
    this.faceEditor = root.querySelector('[data-d6-face-editor]');
    this.stage = root.querySelector('[data-d6-stage]');
    this.mockup = root.querySelector('[data-d6-mockup]');
    this.diceLayer = root.querySelector('[data-d6-dice-layer]');
    this.faceClipRect = root.querySelector('[data-d6-face-clip]');
    this.faceFiles = [...root.querySelectorAll('[data-d6-face-file]')];
    this.previewFile = root.querySelector('[data-d6-preview-file]');
    this.orderStatus = root.querySelector('[data-d6-order-status]');
    this.ids = {
      clip: `D6FaceClip-${this.sectionId}`, crystal: `D6Crystal-${this.sectionId}`,
      topLight: `D6TopLight-${this.sectionId}`, sideLight: `D6SideLight-${this.sectionId}`,
      marble: `D6Marble-${this.sectionId}`, matte: `D6Matte-${this.sectionId}`,
      glitter: `D6Glitter-${this.sectionId}`, glowGreen: `D6GlowGreen-${this.sectionId}`,
      glowWhite: `D6GlowWhite-${this.sectionId}`, rainbowRed: `D6RainbowRed-${this.sectionId}`,
      rainbowPurple: `D6RainbowPurple-${this.sectionId}`, rainbowForwardLeft: `D6RainbowForwardLeft-${this.sectionId}`, rainbowForwardRight: `D6RainbowForwardRight-${this.sectionId}`,
      rainbowReverseLeft: `D6RainbowReverseLeft-${this.sectionId}`, rainbowReverseRight: `D6RainbowReverseRight-${this.sectionId}`, rainbowGlass: `D6RainbowGlass-${this.sectionId}`,
    };
    this.installRainbowGradients();
    this.buildSelector();
    this.buildEditor();
    this.bindControls();
    this.applyProductRules();
    this.connectProductForm();
    this.render();
    this.syncOrderFields();
  }

  query(selector) { return this.root.querySelector(selector); }
  installRainbowGradients() {
    const defs = this.mockup.querySelector('defs');
    const bands = [['0', '#e21b3c'], ['.12', '#e21b3c'], ['.17', '#f26f21'], ['.26', '#f26f21'], ['.31', '#f2cf2f'], ['.40', '#f2cf2f'], ['.45', '#35ad62'], ['.54', '#35ad62'], ['.59', '#18a9bd'], ['.68', '#18a9bd'], ['.73', '#315ecb'], ['.82', '#315ecb'], ['.87', '#8736a6'], ['1', '#8736a6']];
    const reverse = [...bands].reverse().map(([offset, color]) => [(1 - Number(offset)).toFixed(2), color]);
    const sets = [
      [this.ids.rainbowRed, '0', '0', '0', '1', [['0', '#ff4359'], ['1', '#c7092a']]],
      [this.ids.rainbowPurple, '0', '0', '0', '1', [['0', '#a844b8'], ['1', '#612078']]],
      [this.ids.rainbowForwardLeft, '.79', '0', '.21', '1', bands],
      [this.ids.rainbowForwardRight, '.21', '0', '.79', '1', bands],
      [this.ids.rainbowReverseLeft, '.79', '0', '.21', '1', reverse],
      [this.ids.rainbowReverseRight, '.21', '0', '.79', '1', reverse],
    ];
    sets.forEach(([id, x1, y1, x2, y2, stops]) => {
      this.mockup.querySelector(`#${id}`)?.remove();
      const gradient = this.element('linearGradient', { id, x1, y1, x2, y2 });
      stops.forEach(([offset, color]) => gradient.appendChild(this.element('stop', { offset, 'stop-color': color, 'stop-opacity': '.78' })));
      defs.appendChild(gradient);
    });
    this.mockup.querySelector(`#${this.ids.rainbowGlass}`)?.remove();
    const glass = this.element('radialGradient', { id: this.ids.rainbowGlass, cx: '.43', cy: '.36', r: '.78' });
    [['0', '#ffffff', '.18'], ['.52', '#ffffff', '0'], ['.78', '#173246', '.08'], ['1', '#07131f', '.48']].forEach(([offset, color, opacity]) => glass.appendChild(this.element('stop', { offset, 'stop-color': color, 'stop-opacity': opacity })));
    defs.appendChild(glass);
  }
  faceIsEditable(index) { return this.editableFaces.has(index + 1); }
  normalize(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase(); }
  mapAllowed(values, mapping) {
    if (!Array.isArray(values)) return [];
    return values.map((value) => mapping[this.normalize(value)] || this.normalize(value)).filter(Boolean);
  }
  restrictSelect(select, values, mapping) {
    const allowed = this.mapAllowed(values, mapping);
    if (!allowed.length) return;
    [...select.options].forEach((option) => { option.hidden = !allowed.includes(option.value); });
    const first = [...select.options].find((option) => !option.hidden);
    if (first) select.value = first.value;
    select.disabled = allowed.length === 1;
  }
  applyColorRules(input, output, values) {
    const colors = Array.isArray(values) ? [...new Set(values.map((color) => String(color).toUpperCase()))] : [];
    if (!colors.length) return;
    input.value = colors[0];
    output.value = colors[0];
    input.hidden = true;
    const palette = document.createElement('div');
    palette.className = 'd6-configurator__palette';
    colors.forEach((color, index) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'd6-configurator__swatch'; button.style.backgroundColor = color;
      button.title = color; button.setAttribute('aria-label', `Seleccionar color ${color}`);
      button.classList.toggle('is-selected', index === 0);
      if (colors.length === 1) button.disabled = true;
      button.addEventListener('click', () => {
        input.value = color; output.value = color;
        [...palette.children].forEach((swatch) => swatch.classList.toggle('is-selected', swatch === button));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      palette.appendChild(button);
    });
    input.parentElement.insertBefore(palette, output);
  }
  applyProductRules() {
    this.restrictSelect(this.material, this.productConfig.finishes, { brillo: 'gloss', mate: 'matte', marmol: 'marble', cristal: 'crystal', glitter: 'glitter', purpurina: 'glitter', 'brilla en la oscuridad': 'glow', fosforescente: 'glow', arcoiris: 'rainbow' });
    this.restrictSelect(this.cornerStyle, this.productConfig.corners, { redondeadas: 'rounded', redondeada: 'rounded', rectas: 'straight', recta: 'straight' });
    this.applyColorRules(this.dieColor, this.dieColorCode, this.productConfig.dieColors);
    this.applyColorRules(this.pipColor, this.pipColorCode, this.productConfig.designColors);
    this.dieColorUsesPalette = this.dieColor.hidden;
    this.cornerStyle.dispatchEvent(new Event('change', { bubbles: true }));
    this.dieColor.dispatchEvent(new Event('input', { bubbles: true }));
    this.pipColor.dispatchEvent(new Event('input', { bubbles: true }));
    this.updateMaterialControls();
    this.syncEditor();
  }
  updateMaterialControls() {
    const material = this.material.value;
    if (!this.normalDieColor) this.normalDieColor = this.dieColor.value;
    this.dieColorControl.hidden = material === 'rainbow';
    let glowPalette = this.dieColorControl.querySelector('[data-d6-glow-palette]');
    const normalPalette = this.dieColorControl.querySelector('.d6-configurator__palette:not([data-d6-glow-palette])');
    if (material === 'glow') {
      if (!glowPalette) {
        glowPalette = document.createElement('div'); glowPalette.dataset.d6GlowPalette = ''; glowPalette.className = 'd6-configurator__palette d6-configurator__glow-palette';
        [['#B7FF66', 'Verde'], ['#F4FFF0', 'Blanco']].forEach(([color, label]) => {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'd6-configurator__swatch'; button.style.backgroundColor = color; button.title = label; button.setAttribute('aria-label', `Fosforescente ${label}`);
          button.addEventListener('click', () => { this.dieColor.value = color; this.dieColorCode.value = label; [...glowPalette.children].forEach((item) => item.classList.toggle('is-selected', item === button)); this.render(); this.syncOrderFields(); });
          glowPalette.appendChild(button);
        });
        this.dieColorControl.querySelector('.d6-configurator__color-row').appendChild(glowPalette);
      }
      this.dieColor.hidden = true; this.dieColorCode.hidden = true; glowPalette.hidden = false; if (normalPalette) normalPalette.hidden = true;
      const isWhite = this.normalize(this.dieColorCode.value) === 'blanco';
      this.dieColor.value = isWhite ? '#F4FFF0' : '#B7FF66'; this.dieColorCode.value = isWhite ? 'Blanco' : 'Verde';
      [...glowPalette.children].forEach((item, index) => item.classList.toggle('is-selected', index === (isWhite ? 1 : 0)));
    } else {
      if (glowPalette) glowPalette.hidden = true;
      if (normalPalette) normalPalette.hidden = false;
      this.dieColor.hidden = this.dieColorUsesPalette; this.dieColorCode.hidden = false;
      if (material !== 'rainbow' && ['#B7FF66', '#F4FFF0'].includes(this.dieColor.value.toUpperCase())) this.dieColor.value = this.normalDieColor;
      this.dieColorCode.value = this.dieColor.value.toUpperCase();
    }
  }
  clamp(number) { return Math.max(0, Math.min(255, number)); }
  shade(hex, amount) {
    const number = parseInt(hex.slice(1), 16);
    return `#${[number >> 16, (number >> 8) & 255, number & 255].map((value) => Math.round(this.clamp(value + amount)).toString(16).padStart(2, '0')).join('')}`;
  }
  luminance(hex) {
    const number = parseInt(hex.slice(1), 16);
    return .2126 * (number >> 16) + .7152 * ((number >> 8) & 255) + .0722 * (number & 255);
  }
  path(points, radius = 0) {
    if (!radius) return `M${points.map((point) => point.join(' ')).join('L')}Z`;
    return `${points.map((corner, index) => {
      const previous = points[(index - 1 + points.length) % points.length];
      const next = points[(index + 1) % points.length];
      const previousLength = Math.hypot(previous[0] - corner[0], previous[1] - corner[1]);
      const nextLength = Math.hypot(next[0] - corner[0], next[1] - corner[1]);
      const rounded = Math.min(radius, previousLength / 3, nextLength / 3);
      const start = [corner[0] + (previous[0] - corner[0]) * rounded / previousLength, corner[1] + (previous[1] - corner[1]) * rounded / previousLength];
      const end = [corner[0] + (next[0] - corner[0]) * rounded / nextLength, corner[1] + (next[1] - corner[1]) * rounded / nextLength];
      return `${index ? 'L' : 'M'}${start.join(' ')}Q${corner.join(' ')} ${end.join(' ')}`;
    }).join('')}Z`;
  }
  element(name, attributes = {}) {
    const element = document.createElementNS(this.svgNamespace, name);
    Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
    return element;
  }

  buildSelector() {
    const selector = document.createElement('div');
    selector.className = 'd6-configurator__face-selector';
    selector.setAttribute('aria-label', 'Caras del dado');
    const positions = [[3, 2], [3, 3], [4, 2], [2, 2], [3, 1], [1, 2]];
    ['⚀', '⚁', '⚂', '⚃', '⚄', '⚅'].forEach((symbol, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = symbol;
      button.title = `Cara ${index + 1}`;
      button.style.gridColumn = positions[index][0];
      button.style.gridRow = positions[index][1];
      if (!this.faceIsEditable(index)) {
        button.classList.add('is-locked');
        button.title = `Cara ${index + 1} fija`;
      }
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        if (!this.faceIsEditable(index)) return;
        this.selectedFace = this.selectedFace === index ? null : index;
        this.syncEditor();
      });
      selector.appendChild(button);
    });
    this.stage.appendChild(selector);
    this.selector = selector;
    this.stage.addEventListener('click', (event) => {
      if (event.target.closest('[data-face],.d6-configurator__face-selector')) return;
      this.selectedFace = null;
      this.syncEditor();
    });
  }

  buildEditor() {
    this.faceEditor.innerHTML = '<div class="d6-configurator__face d6-configurator__editor-empty" data-d6-editor-card><div class="d6-configurator__face-head"><span class="d6-configurator__face-title" data-d6-editor-title>Selecciona una cara</span><span class="d6-configurator__status" data-d6-editor-status>Sin selección</span></div><p class="d6-configurator__face-help" data-d6-opposite-text>Usa el selector o pulsa una cara del dado.</p><div class="d6-configurator__actions"><button type="button" class="d6-configurator__image-button" data-d6-image-button>Imagen</button><button type="button" class="d6-configurator__pips-button" data-d6-pips-button>Puntos</button><button type="button" class="d6-configurator__clear-button" data-d6-clear-button>Borrar</button></div><div class="d6-configurator__range-row"><input data-d6-editor-size type="range" min="20" max="180" value="76"><output data-d6-editor-size-value>76%</output></div></div>';
    this.editorCard = this.query('[data-d6-editor-card]');
    this.editorTitle = this.query('[data-d6-editor-title]');
    this.editorStatus = this.query('[data-d6-editor-status]');
    this.oppositeText = this.query('[data-d6-opposite-text]');
    this.editorSize = this.query('[data-d6-editor-size]');
    this.editorSizeValue = this.query('[data-d6-editor-size-value]');
    this.query('[data-d6-image-button]').addEventListener('click', () => {
      if (this.selectedFace !== null) this.faceFiles[this.selectedFace].click();
    });
    this.query('[data-d6-pips-button]').addEventListener('click', () => {
      if (this.selectedFace === null) return;
      this.state[this.selectedFace].mode = 'pips';
      this.faceFiles[this.selectedFace].value = '';
      this.syncEditor(); this.render(); this.syncOrderFields();
    });
    this.query('[data-d6-clear-button]').addEventListener('click', () => {
      if (this.selectedFace === null) return;
      this.state[this.selectedFace].mode = 'blank';
      this.faceFiles[this.selectedFace].value = '';
      this.syncEditor(); this.render(); this.syncOrderFields();
    });
    this.editorSize.addEventListener('input', (event) => {
      if (this.selectedFace === null) return;
      this.state[this.selectedFace].size = Number(event.target.value);
      this.editorSizeValue.value = `${event.target.value}%`;
      this.scheduleRender(); this.syncOrderFields();
    });
    this.faceFiles.forEach((input, index) => input.addEventListener('change', (event) => this.loadFaceFile(index, event.target.files[0])));
    this.syncEditor();
  }

  async loadFaceFile(index, file) {
    if (!file) return;
    const face = this.state[index];
    const reader = new FileReader();
    if (file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg')) {
      reader.onload = async () => {
        face.svgSource = reader.result; face.vectorRaster = null; face.vectorKey = null; face.image = null; face.mode = 'image';
        this.syncEditor(); await this.prepareVector(face); this.render(); this.syncOrderFields();
      };
      reader.readAsText(file);
    } else {
      reader.onload = () => {
        face.image = reader.result; face.svgSource = null; face.vectorRaster = null; face.vectorKey = null; face.mode = 'image';
        this.syncEditor(); this.render(); this.syncOrderFields();
      };
      reader.readAsDataURL(file);
    }
  }

  bindControls() {
    this.dieColor.addEventListener('input', (event) => { this.normalDieColor = event.target.value; this.dieColorCode.value = event.target.value.toUpperCase(); this.scheduleRender(); this.syncOrderFields(); });
    this.pipColor.addEventListener('input', (event) => { this.pipColorCode.value = event.target.value.toUpperCase(); this.scheduleVectorRender(); this.syncOrderFields(); });
    this.material.addEventListener('change', () => { this.updateMaterialControls(); this.render(); this.syncOrderFields(); });
    this.cornerStyle.addEventListener('change', () => { this.render(); this.syncOrderFields(); });
    this.recolorSvg.addEventListener('change', () => { this.prepareVectorsAndRender(); this.syncOrderFields(); });
  }

  async prepareVector(face) {
    if (!face.svgSource) return;
    const key = `${this.pipColor.value}|${this.recolorSvg.checked}`;
    if (face.vectorKey === key && face.vectorRaster) return;
    const url = URL.createObjectURL(new Blob([face.svgSource], { type: 'image/svg+xml' }));
    try {
      const image = new Image(); image.src = url; await image.decode();
      const canvas = document.createElement('canvas'); const side = 1024; canvas.width = side; canvas.height = side;
      const context = canvas.getContext('2d');
      const ratio = Math.min(side / (image.naturalWidth || side), side / (image.naturalHeight || side));
      const width = (image.naturalWidth || side) * ratio; const height = (image.naturalHeight || side) * ratio;
      context.drawImage(image, (side - width) / 2, (side - height) / 2, width, height);
      if (this.recolorSvg.checked) { context.globalCompositeOperation = 'source-in'; context.fillStyle = this.pipColor.value; context.fillRect(0, 0, side, side); }
      face.vectorRaster = canvas.toDataURL('image/png'); face.vectorKey = key;
    } catch (error) {
      face.vectorRaster = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(face.svgSource)}`; face.vectorKey = key;
    } finally { URL.revokeObjectURL(url); }
  }
  async prepareVectorsAndRender() { await Promise.all(this.state.filter((face) => face.svgSource).map((face) => this.prepareVector(face))); this.render(); }
  scheduleVectorRender() { clearTimeout(this.vectorTimer); this.vectorTimer = setTimeout(() => { this.vectorTimer = 0; this.prepareVectorsAndRender(); }, 60); }
  scheduleRender() { clearTimeout(this.renderTimer); this.renderTimer = setTimeout(() => { this.renderTimer = 0; this.render(); }, 32); }
  modeName(face) { return face.mode === 'pips' ? `Puntos · ${face.number}` : face.mode === 'image' ? 'Imagen' : 'Vacía'; }

  syncEditor() {
    [...this.selector.children].forEach((button, index) => {
      button.classList.toggle('is-active', index === this.selectedFace);
      button.classList.toggle('is-opposite', this.selectedFace !== null && index === this.opposites[this.selectedFace]);
    });
    if (this.selectedFace === null) {
      this.editorCard.classList.add('d6-configurator__editor-empty'); this.editorTitle.textContent = 'Selecciona una cara';
      this.editorStatus.textContent = 'Sin selección'; this.oppositeText.textContent = 'Usa el selector o pulsa una cara del dado.';
      this.editorSize.value = 76; this.editorSizeValue.value = '—'; return;
    }
    const face = this.state[this.selectedFace];
    this.editorCard.classList.remove('d6-configurator__editor-empty'); this.editorTitle.textContent = `Cara ${this.selectedFace + 1}`;
    this.editorStatus.textContent = this.modeName(face); this.oppositeText.textContent = `Cara opuesta: ${this.opposites[this.selectedFace] + 1}`;
    this.editorSize.value = face.size; this.editorSizeValue.value = `${face.size}%`;
  }

  art(group, index, transform) {
    const art = this.element('g', { transform, 'clip-path': `url(#${this.ids.clip})`, id: `ARTE_CARA_${index + 1}` });
    const face = this.state[index];
    if (face.mode === 'pips') {
      this.pips[face.number].forEach((point) => art.appendChild(this.element('circle', { cx: point[0], cy: point[1], r: 40, fill: this.pipColor.value, stroke: '#fff', 'stroke-opacity': '.18', 'stroke-width': 5 })));
    } else if (face.mode === 'image' && (face.image || face.vectorRaster)) {
      const size = 400 * face.size / 100; const offset = (400 - size) / 2;
      const image = this.element('image', { x: offset, y: offset, width: size, height: size, preserveAspectRatio: 'xMidYMid meet' });
      image.setAttributeNS(this.xlinkNamespace, 'href', face.svgSource ? face.vectorRaster : face.image); art.appendChild(image);
    }
    group.appendChild(art);
  }

  render() {
    this.diceLayer.replaceChildren();
    const color = this.dieColor.value; const material = this.material.value; const rounded = this.cornerStyle.value === 'rounded';
    const radius = rounded ? 104 : 0; const darkMarble = material === 'marble' && this.luminance(color) < 55;
    this.faceClipRect.setAttribute('rx', rounded ? 108 : 0); this.faceClipRect.setAttribute('ry', rounded ? 108 : 0);
    this.layouts.forEach((layout, layoutIndex) => {
      const group = this.element('g'); const outer = [layout.points.top[0], layout.points.top[1], layout.points.right[2], layout.points.right[3], layout.points.left[3], layout.points.left[0]];
      group.appendChild(this.element('path', { d: this.path(outer, radius), fill: material === 'rainbow' ? '#547080' : darkMarble ? this.shade(color, 10) : this.shade(color, -22), opacity: material === 'crystal' ? '.28' : material === 'rainbow' ? '.18' : '1' }));
      const fill = darkMarble ? { top: this.shade(color, 68), left: this.shade(color, 40), right: this.shade(color, 24) } : { top: material === 'crystal' ? color : this.shade(color, 30), left: material === 'crystal' ? this.shade(color, -7) : this.shade(color, -3), right: material === 'crystal' ? this.shade(color, -20) : this.shade(color, -28) };
      this.keys.forEach((key, index) => {
        const faceIndex = layout.faces[index];
        const direction = layoutIndex === 0 ? 'Forward' : 'Reverse';
        const rainbowSide = this.ids[`rainbow${direction}${key === 'left' ? 'Left' : 'Right'}`];
        const rainbowFill = key === 'top' ? `url(#${faceIndex === 0 ? this.ids.rainbowRed : this.ids.rainbowPurple})` : `url(#${rainbowSide})`;
        const faceFill = material === 'rainbow' ? rainbowFill : material === 'glow' ? `url(#${color.toUpperCase() === '#F4FFF0' ? this.ids.glowWhite : this.ids.glowGreen})` : fill[key];
        group.appendChild(this.element('path', { d: this.path(layout.points[key], radius), fill: faceFill, filter: material === 'matte' ? `url(#${this.ids.matte})` : material === 'marble' ? `url(#${this.ids.marble})` : '', opacity: material === 'crystal' ? '.64' : material === 'rainbow' ? '.46' : '1', stroke: material === 'rainbow' ? '#fff' : 'none', 'stroke-opacity': material === 'rainbow' ? '.55' : '0', 'stroke-width': material === 'rainbow' ? '4' : '0' }));
      });
      if (['crystal', 'rainbow'].includes(material)) this.keys.forEach((key) => group.appendChild(this.element('path', { d: this.path(layout.points[key], radius), fill: `url(#${material === 'rainbow' ? this.ids.rainbowGlass : this.ids.crystal})`, opacity: material === 'rainbow' ? '.78' : '.48', 'pointer-events': 'none' })));
      if (material === 'glitter') this.keys.forEach((key) => group.appendChild(this.element('path', { d: this.path(layout.points[key], radius), fill: `url(#${this.ids.glitter})`, opacity: '.82', 'pointer-events': 'none' })));
      this.keys.forEach((key, index) => this.art(group, layout.faces[index], layout.transforms[key]));
      this.keys.forEach((key) => group.appendChild(this.element('path', { d: this.path(layout.points[key], radius), fill: key === 'top' ? `url(#${this.ids.topLight})` : `url(#${this.ids.sideLight})`, opacity: material === 'matte' ? '.13' : material === 'marble' ? darkMarble ? '.12' : '.18' : material === 'rainbow' ? '.9' : material === 'crystal' ? '.42' : material === 'glow' ? '.5' : '.66', 'pointer-events': 'none' })));
      this.keys.forEach((key, index) => {
        const faceIndex = layout.faces[index]; const editable = this.faceIsEditable(faceIndex); const hit = this.element('path', { d: this.path(layout.points[key], radius), fill: '#000', opacity: '0', cursor: editable ? 'pointer' : 'default', 'data-face': faceIndex + 1 });
        hit.addEventListener('click', (event) => { event.stopPropagation(); if (!editable) return; this.selectedFace = this.selectedFace === faceIndex ? null : faceIndex; this.syncEditor(); }); group.appendChild(hit);
      });
      this.diceLayer.appendChild(group);
    });
  }

  exportSvg() {
    const clone = this.mockup.cloneNode(true);
    clone.querySelectorAll('[data-face]').forEach((node) => node.remove());
    clone.setAttribute('xmlns', this.svgNamespace); clone.setAttribute('xmlns:xlink', this.xlinkNamespace);
    clone.setAttribute('width', '1600'); clone.setAttribute('height', '1600'); clone.setAttribute('viewBox', '0 0 1600 1600');
    const background = clone.querySelector(':scope > rect'); if (background) background.setAttribute('height', '1600');
    const group = document.createElementNS(this.svgNamespace, 'g'); group.setAttribute('transform', 'translate(0 300)');
    [...clone.children].filter((node) => node.tagName.toLowerCase() !== 'defs' && node !== background).forEach((node) => group.appendChild(node));
    clone.appendChild(group); return clone;
  }
  svgText() { return `<?xml version="1.0" encoding="UTF-8"?>\n${new XMLSerializer().serializeToString(this.exportSvg())}`; }
  async createPngBlob() {
    await this.prepareVectorsAndRender();
    const url = URL.createObjectURL(new Blob([this.svgText()], { type: 'image/svg+xml' }));
    try {
      const image = new Image(); image.src = url; await image.decode();
      const canvas = document.createElement('canvas'); canvas.width = 1600; canvas.height = 1600;
      canvas.getContext('2d').drawImage(image, 0, 0, 1600, 1600);
      return await new Promise((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('No se pudo crear la vista previa.')), 'image/png'));
    } finally { URL.revokeObjectURL(url); }
  }
  syncOrderFields() {
    const materialNames = { gloss: 'Brillo', matte: 'Mate', marble: 'Mármol', crystal: 'Cristal', glitter: 'Glitter', glow: 'Brilla en la oscuridad', rainbow: 'Arcoíris' };
    this.query('[data-d6-property="material"]').value = materialNames[this.material.value];
    this.query('[data-d6-property="dieColor"]').value = this.material.value === 'rainbow' ? 'Arcoíris (sin color único)' : this.material.value === 'glow' ? this.dieColorCode.value : this.dieColor.value.toUpperCase();
    this.query('[data-d6-property="pipColor"]').value = this.pipColor.value.toUpperCase();
    this.query('[data-d6-property="corners"]').value = this.cornerStyle.value === 'rounded' ? 'Redondeadas' : 'Rectas';
    this.state.forEach((face, index) => { this.query(`[data-d6-face-status="${index + 1}"]`).value = `${this.modeName(face)} · Tamaño ${face.size}%`; });
  }

  appendOrderData(formData) {
    this.syncOrderFields();
    this.root.querySelectorAll('.d6-configurator__order-fields input[type="hidden"]').forEach((input) => {
      formData.set(input.name, input.value);
    });
    this.faceFiles.forEach((input) => {
      if (input.files[0]) formData.set(input.name, input.files[0], input.files[0].name);
    });
    if (this.previewFile.files[0]) formData.set(this.previewFile.name, this.previewFile.files[0], this.previewFile.files[0].name);
  }

  connectProductForm() {
    const form = document.querySelector('[id^="MainProduct-"] product-form form[data-type="add-to-cart-form"]');
    if (!form) { this.orderStatus.textContent = 'El configurador está listo, pero debe colocarse en una plantilla de producto.'; return; }
    if (!form.id) form.id = `D6ProductForm-${this.sectionId}`;
    this.root.querySelectorAll('.d6-configurator__order-fields input').forEach((input) => input.setAttribute('form', form.id));
    form.addEventListener('formdata', (event) => this.appendOrderData(event.formData));
    form.addEventListener('submit', async (event) => {
      if (this.preparedSubmit) { this.preparedSubmit = false; return; }
      event.preventDefault(); event.stopImmediatePropagation();
      const submitter = event.submitter;
      try {
        this.orderStatus.textContent = 'Preparando el diseño para añadirlo al carrito…';
        this.syncOrderFields();
        const preview = new File([await this.createPngBlob()], `mockup-d6-${Date.now()}.png`, { type: 'image/png' });
        const transfer = new DataTransfer(); transfer.items.add(preview); this.previewFile.files = transfer.files;
        this.preparedSubmit = true; this.orderStatus.textContent = 'Diseño preparado.';
        form.requestSubmit(submitter || undefined);
      } catch (error) {
        this.orderStatus.textContent = 'No se pudo preparar la vista previa. Revisa los archivos y vuelve a intentarlo.';
        console.error(error);
      }
    }, true);
  }
}

const initializeD6Configurators = (scope = document) => {
  scope.querySelectorAll('[data-d6-configurator]:not([data-d6-ready])').forEach((root) => {
    root.dataset.d6Ready = 'true'; new D6Configurator(root);
  });
};

initializeD6Configurators();
document.addEventListener('shopify:section:load', (event) => initializeD6Configurators(event.target));
